import {twMerge} from '../../../common/twMerge';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {ControlProps} from './ControlProps.interface';

export function Control({
  count = 0,
  isMinusDisabled = false,
  isPlusDisabled = false,
  onClickMinus,
  onClickPlus,
  isLoggingZoom = false,
  className,
  ...props
}: ControlProps) {
  return (
    <div
      className={twMerge('flex flex-row items-center', className)}
      {...props}
    >
      <Icon
        className={!isMinusDisabled ? 'cursor-pointer' : undefined}
        type={IconType.ButtonMinus}
        disabled={isMinusDisabled}
        onClick={!isMinusDisabled ? onClickMinus : undefined}
        {...putTiaraObjectProps({
          click: {
            copy: isLoggingZoom ? '축소' : '마이너스',
          },
        })}
      />
      <div className="mx-4pxr flex h-18pxr w-34pxr items-center justify-center">
        <Text className="font-small1-bold text-theme-solid-100">{count}</Text>
      </div>
      <Icon
        className={!isPlusDisabled ? 'cursor-pointer' : undefined}
        type={IconType.ButtonPlusL}
        disabled={isPlusDisabled}
        onClick={!isPlusDisabled ? onClickPlus : undefined}
        {...putTiaraObjectProps({
          click: {
            copy: isLoggingZoom ? '확대' : '플러스',
          },
        })}
      />
    </div>
  );
}
